import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { MISSING_BY_COUNTRY_URL } from "./apiEndpoints";
import type { ApiResponse, MissingByCountryItem } from "./types";

type UseGetMissingByCountryOptions = Omit<
  UseGetServiceOptions<ApiResponse<MissingByCountryItem[]>>,
  "route" | "queryKey"
>;

export const useGetMissingByCountry = (options?: UseGetMissingByCountryOptions) =>
  useGetService<ApiResponse<MissingByCountryItem[]>>({
    route: MISSING_BY_COUNTRY_URL,
    queryKey: ["dq-dashboard", "missing-by-country"],
    retry: false,
    ...(options ?? {}),
  });
